export default __webpack_public_path__ + "c97a6ccfc366fea3c11135def54324a2.jpg";